module.exports = __webpack_public_path__ + "img/zhengshu1.e5e04094.png";